import { render, staticRenderFns } from "./Synthesis.vue?vue&type=template&id=2c31e7d8&scoped=true"
import script from "./Synthesis.vue?vue&type=script&lang=ts"
export * from "./Synthesis.vue?vue&type=script&lang=ts"
import style0 from "./Synthesis.vue?vue&type=style&index=0&id=2c31e7d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c31e7d8",
  null
  
)

export default component.exports